import type { RouteObject } from "react-router-dom";

import { RootRedirect } from "@/components/shared/RootRedirect";
import { AuthCallback, Login, MobileAuthCallback, Privacy, Register, Terms } from "@/router/lazyPages/public";
import { NotFound } from "@/router/lazyPages/shared";
import { fullscreenSuspense } from "@/router/helpers";

export const publicRoutes: RouteObject[] = [
  { path: "/login", element: fullscreenSuspense(<Login />) },
  { path: "/register", element: fullscreenSuspense(<Register />) },
  { path: "/terms", element: fullscreenSuspense(<Terms />) },
  { path: "/privacy", element: fullscreenSuspense(<Privacy />) },
  { path: "/auth/callback", element: fullscreenSuspense(<AuthCallback />) },
  {
    path: "/auth/mobile-callback",
    element: fullscreenSuspense(<MobileAuthCallback />),
  },
  { path: "/", element: <RootRedirect /> },
];

export const notFoundRoute: RouteObject = {
  path: "*",
  element: fullscreenSuspense(<NotFound />),
};
